import { supabase } from '@/core/database/supabase';
import { enforceSettingsPermission } from '@/modules/settings/permissions/enforceSettingsPermission';
import type { TemplateRecord } from '../../list/types/templates.types';

export const templatesEditService = {
  async getTemplate(id: string): Promise<TemplateRecord> {
    await enforceSettingsPermission('settings.templates.view');
    
    const { data, error } = await supabase
      .from('settings_templates')
      .select('*')
      .eq('id', id)
      .single();

    if (error) throw error;
    
    return {
      id: data.id,
      companyId: data.company_id,
      name: data.name,
      code: data.code,
      description: data.description,
      type: data.type,
      usageCount: data.usage_count,
      status: data.status,
      content: data.content,
      createdBy: data.created_by,
      createdAt: data.created_at,
      updatedAt: data.updated_at
    };
  },

  async updateTemplate(id: string, data: Partial<TemplateRecord>) {
    await enforceSettingsPermission('settings.templates.manage');
    
    const { error } = await supabase
      .from('settings_templates')
      .update({
        name: data.name,
        description: data.description,
        type: data.type,
        status: data.status,
        content: data.content,
        updated_at: new Date().toISOString(),
      })
      .eq('id', id);

    if (error) throw error;
  }
};
